<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-09-22 09:50:47
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 11:00:54
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 接口设置 -->
    <api-interface
      :data="data"
      :apis="main.apiTableList"
    >
      <template v-slot:extend>
        <echart-field :data="data" />
        <echart-filter :data="data" />
      </template>
    </api-interface>

    <el-collapse-item title="仪表盘">
      <el-form-item label="起始角度">
        <el-input-number
          v-model="data.option.startAngle"
          :min="-360"
          :max="360"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="结束角度">
        <el-input-number
          v-model="data.option.endAngle"
          :min="-360"
          :max="360"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="分割段数">
        <el-input-number
          v-model="data.option.splitNumber"
          :min="1"
          :max="100"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="横坐标(%)">
        <el-slider
          v-model="data.option.centerX"
          :min="0"
          :max="100"
        />
      </el-form-item>

      <el-form-item label="纵坐标(%)">
        <el-slider
          v-model="data.option.centerY"
          :min="0"
          :max="100"
        />
      </el-form-item>

      <el-form-item label="半径(%)">
        <el-slider
          v-model="data.option.centerR"
          :min="0"
          :max="100"
        />
      </el-form-item>

      <!-- <el-form-item label="最小数据值">
        <el-slider
          v-model="data.option.min"
          :min="0"
          :max="100"
          placeholder="请输入"
        />
      </el-form-item> -->

      <el-form-item label="最大数据值">
        <el-slider
          v-model="data.option.max"
          :min="0"
          :max="100"
        />
      </el-form-item>

      <el-form-item label="圆形轴线">
        <el-switch
          v-model="data.option.roundCap"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="轴线宽度">
        <el-slider
          v-model="data.option.lineWidth"
          :min="0"
          :max="50"
        />
      </el-form-item>

      <el-form-item label="轴线颜色">
        <el-color-picker
          v-model="data.option.lineColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="显示进度条">
        <el-switch
          v-model="data.option.progressShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item
        label="进度条颜色"
        v-if="data.option.progressShow"
      >
        <el-color-picker
          v-model="data.option.progressColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="显示分隔线">
        <el-switch
          v-model="data.option.splitLineShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item
        label="分隔线线长"
        v-if="data.option.splitLineShow"
      >
        <el-slider
          v-model="data.option.splitLineLength"
          :min="0"
          :max="50"
        />
      </el-form-item>

      <el-form-item
        label="分隔线线宽"
        v-if="data.option.splitLineShow"
      >
        <el-slider
          v-model="data.option.splitLineWidth"
          :min="0"
          :max="10"
          :step="1"
        />
      </el-form-item>

      <el-form-item
        label="分割线颜色"
        v-if="data.option.splitLineShow"
      >
        <el-color-picker
          v-model="data.option.splitLineColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="显示刻度">
        <el-switch
          v-model="data.option.axisTickShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item
        label="刻度线长"
        v-if="data.option.axisTickShow"
      >
        <el-slider
          v-model="data.option.axisTickLength"
          :min="0"
          :max="50"
        />
      </el-form-item>

      <el-form-item
        label="刻度线宽"
        v-if="data.option.axisTickShow"
      >
        <el-slider
          v-model="data.option.axisTickWidth"
          :min="0"
          :max="10"
          :step="1"
        />
      </el-form-item>

      <el-form-item
        label="刻度颜色"
        v-if="data.option.axisTickShow"
      >
        <el-color-picker
          v-model="data.option.axisTickColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="显示指针">
        <el-switch
          v-model="data.option.pointerShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item
        label="指针线长"
        v-if="data.option.pointerShow"
      >
        <el-slider
          v-model="data.option.pointerLength"
          :min="0"
          :max="100"
          :step="1"
        />
      </el-form-item>

      <el-form-item
        label="指针线宽"
        v-if="data.option.pointerShow"
      >
        <el-slider
          v-model="data.option.pointerWidth"
          :min="0"
          :max="30"
          :step="1"
        />
      </el-form-item>

      <el-form-item
        label="指针颜色"
        v-if="data.option.pointerShow"
      >
        <el-color-picker
          v-model="data.option.pointerColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="显示固定点">
        <el-switch
          v-model="data.option.anchorShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item
        label="固定点大小"
        v-if="data.option.anchorShow"
      >
        <el-slider
          v-model="data.option.anchorSize"
          :min="6"
          :max="50"
          :step="1"
        />
      </el-form-item>

      <el-form-item
        label="固定点颜色"
        v-if="data.option.anchorShow"
      >
        <el-color-picker
          v-model="data.option.anchorColor"
          :predefine="predefineColors"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 标题设置 -->
    <el-collapse-item title="标题设置">
      <el-form-item label="显示">
        <el-switch
          v-model="data.option.gaugeTitleShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="距离">
        <el-input-number
          v-model="data.option.gaugeTitleCenter"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.gaugeTitleFontSize"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.gaugeTitleColor"
          :predefine="predefineColors"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 数值设置 -->
    <el-collapse-item title="数值设置">
      <el-form-item label="显示">
        <el-switch
          v-model="data.option.detailShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="单位">
        <el-input
          v-model="data.option.unit"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="距离">
        <el-input-number
          v-model="data.option.detailCenter"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.detailFontSize"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.detailColor"
          :predefine="predefineColors"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 标签设置 -->
    <el-collapse-item title="标签设置">
      <el-form-item label="显示">
        <el-switch
          v-model="data.option.labelShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="formatter">
        <el-button
          size="small"
          type="primary"
          @click="setFormatter(data.option.labelFormatter, 'label')"
        >设置</el-button>
      </el-form-item>

      <el-form-item label="距离">
        <el-input-number
          v-model="data.option.labelDistance"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.labelFontSize"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.labelColor"
          :predefine="predefineColors"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 轴线颜色 -->
    <echart-color
      title="轴线颜色扩展"
      :data="data"
    />

    <!-- 链接 -->
    <config-link :data="data" />

    <!-- formatter -->
    <echart-formatter
      :show.sync="formatter.show"
      :formatter="formatter.code"
      @change="updateFormatter"
    />

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>
<script>
import configBase from '@/dragComponents/config/common/base.vue'
import configLink from '@/dragComponents/config/common/link.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'
import apiInterface from '@/dragComponents/config/api/index.vue'
import echartField from '@/dragComponents/config/common/field.vue'
import echartFilter from '@/dragComponents/config/common/filter.vue'
import echartFormatter from '@/dragComponents/config/common/formatter.vue'
import echartColor from '@/dragComponents/config/common/color.vue'

import {
  predefineColors,
  component,
  theme
} from '@/dragComponents/model/default.js'

export default {
  name: 'config-echart-gauge',
  components: {
    configBase,
    configLink,
    configAuth,
    echartColor,
    echartField,
    echartFilter,
    echartFormatter,
    apiInterface
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component,
      formatter: {
        show: false,
        code: '',
        type: 'tips'
      }
    }
  },
  methods: {
    setFormatter(val, type) {
      this.formatter.code = val
      this.formatter.type = type
      this.formatter.show = true
    },
    updateFormatter(val) {
      let self = this
      switch (self.formatter.type) {
        case 'label':
          self.data.option.labelFormatter = val
          break
        default:
      }
    }
  }
}
</script>
